// extracted by mini-css-extract-plugin
export var standaloneTable = "_fp-0";
export var standaloneTableWithBodyFill = "_fp-1";
export var withExtraHeader = "_fp-2";